export const GET_BAG_REQUEST = "GET_BAG_REQUEST"
export const GET_BAG_SUCCESS = "GET_BAG_SUCCESS"
export const GET_BAG_FAILURE = "GET_BAG_FAILURE"
